import type { CrudModalField } from "@/components/tables/fields/crudModalField";

type Translate = (key: string) => string;
type EntityOptionField = Pick<
  CrudModalField,
  "entity" | "userEntityValueField"
>;

export const toEntityOptionValue = (item: any, field: EntityOptionField) => {
  if (field.entity === "user" && field.userEntityValueField === "subject_id") {
    return item?.subject_id ?? item?.id ?? item?.value;
  }
  return item?.id ?? item?.value;
};

export const toEntityOption = (
  item: any,
  field: EntityOptionField,
  t: Translate
) => {
  let label = item?.name || item?.label || "";
  if (field.entity === "user") {
    const firstName = item?.first_name || "";
    const lastName = item?.last_name || "";
    label = `${lastName}${lastName && firstName ? ", " : ""}${firstName}`;
  } else if (field.entity === "trackedServiceTemplate") {
    label = item?.internal_name || item?.name || "";
  } else if (item?.name || item?.label) {
    const translatedName = item?.name ? t(item.name) : "";
    const translatedLabel = item?.label ? t(item.label) : "";
    label = translatedName === "" ? translatedLabel : translatedName;
  }

  if (!label) {
    label = String(toEntityOptionValue(item, field) ?? "");
  }

  return { value: toEntityOptionValue(item, field), label };
};

export const toAsyncEntityPreselection = (
  value: any,
  field: EntityOptionField & Pick<CrudModalField, "multiselect">,
  t: Translate
) => {
  if (field.multiselect) {
    if (!Array.isArray(value)) return [];
    return value
      .map((item: any) =>
        typeof item === "object" ? toEntityOption(item, field, t) : null
      )
      .filter(Boolean);
  }
  if (value && typeof value === "object")
    return toEntityOption(value, field, t);
  return [];
};
